<template>
  <b-modal
    id="org-connectivity-config"
    centered
    hide-header
    hide-footer
    @show="reset"
    @hidden="reset"
  >
    <h3 class="mb-3">Config</h3>
    <form @submit.prevent="save">
      <b-form-group label="Web App URL">
        <b-form-input
          v-model="form.mara_url"
          placeholder="https://app.nanome.ai"
        />
      </b-form-group>
      <b-form-group label="Workspace API URL">
        <b-form-input
          v-model="form.workspace_url"
          placeholder="https://workspaces.nanome.ai"
        />
      </b-form-group>
      <b-btn
        v-b-toggle.alternate-server
        class="mb-2 px-0 text-left"
        variant="none"
        block
      >
        Alternate Server
        <i class="icon-arrow-down" />
      </b-btn>
      <b-collapse id="alternate-server" v-model="showAlt">
        <b-form-group label="Alternate Web App URL">
          <b-form-input
            v-model="form.mara_url_alt"
            placeholder="https://app.nanome.ai"
          />
        </b-form-group>
        <b-form-group label="Alternate Workspace API URL">
          <b-form-input
            v-model="form.workspace_url_alt"
            placeholder="https://workspaces.nanome.ai"
          />
        </b-form-group>
      </b-collapse>
      <div class="mt-4 text-right">
        <b-btn
          class="ml-2 px-4"
          variant="secondary"
          @click="$bvModal.hide('org-connectivity-config')"
        >
          Cancel
        </b-btn>
        <b-btn
          :disabled="!hasChanges"
          class="ml-2 px-4"
          variant="primary"
          type="submit"
        >
          Save
        </b-btn>
      </div>
    </form>
  </b-modal>
</template>

<script>
import API from "@/api";

export default {
  props: {
    org: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    form: {
      mara_url: "",
      workspace_url: "",
      mara_url_alt: "",
      workspace_url_alt: ""
    },
    showAlt: false
  }),

  computed: {
    hasChanges() {
      return (
        this.form.mara_url !== this.org.settings.mara_url ||
        this.form.workspace_url !== this.org.settings.workspace_url ||
        this.form.mara_url_alt !== this.org.settings.mara_url_alt ||
        this.form.workspace_url_alt !== this.org.settings.workspace_url_alt
      );
    }
  },

  methods: {
    reset() {
      this.form.mara_url = this.org.settings.mara_url;
      this.form.workspace_url = this.org.settings.workspace_url;
      this.form.mara_url_alt = this.org.settings.mara_url_alt;
      this.form.workspace_url_alt = this.org.settings.workspace_url_alt;
      this.showAlt = !!(this.form.mara_url_alt || this.form.workspace_url_alt);
    },

    async save() {
      const { success } = await API.updateOrgConnectivity(this.org.id, {
        mara_url: this.form.mara_url,
        workspace_url: this.form.workspace_url,
        mara_url_alt: this.form.mara_url_alt,
        workspace_url_alt: this.form.workspace_url_alt
      });
      if (!success) return;

      this.$emit("updated");
      this.$bvModal.hide("org-connectivity-config");
      this.$notify({
        type: "success",
        text: "Org config updated"
      });
    }
  }
};
</script>
